const Secure = () => {
  return (
    <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 8C12 7.17275 11.3273 6.5 10.5 6.5H9.75V4.25C9.75 2.18225 8.06775 0.5 6 0.5C3.93225 0.5 2.25 2.18225 2.25 4.25V6.5H1.5C0.67275 6.5 0 7.17275 0 8V14C0 14.8273 0.67275 15.5 1.5 15.5H10.5C11.3273 15.5 12 14.8273 12 14V8ZM3.75 4.25C3.75 3.0095 4.7595 2 6 2C7.2405 2 8.25 3.0095 8.25 4.25V6.5H3.75V4.25Z"
        fill="#5D6166"
      />
    </svg>
  );
};

export default Secure;
